export default __webpack_public_path__ + "static/media/mongo.6dfd1093.jpg";